const CardIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect
                x="3.3335"
                y="5"
                width="13.3333"
                height="10"
                rx="1"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.3335 7.91675H16.6668"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="10.8332" cy="11.6667" r="1.66667" fill={color} />
            <circle cx="13.3332" cy="11.6667" r="1.66667" fill={color} />
        </svg>
    )
}

export default CardIcon
